
export const  alertsFields=[
    {
      label: "Identificador",
      field: "id", 
      sort: "asc",
      width: 150,
    },
    {
      label: "Robot code",
      field: "robotCode",
      sort: "asc",
      width: 270,
    },
    {
      label: "Tiempo de inicio",
      field: "beginTime",
      sort: "asc",
      width: 200,
    },
    {
      label: "Mensaje error",
      field: "warnContent",
      sort: "asc",
      width: 200,
    },
    {
      label: "Codigo de tarea",
      field: "taskCode", //rcs_position_status
      sort: "asc",
      width: 200,
    },
  ]
  

